/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_5_YearInputs */

const en_plan_5_year = /** @type {(inputs: Plan_5_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 year plan`)
};

const es_plan_5_year = /** @type {(inputs: Plan_5_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan de 5 años`)
};

/**
* | output |
* | --- |
* | "5 year plan" |
*
* @param {Plan_5_YearInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_5_year = /** @type {((inputs?: Plan_5_YearInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_5_YearInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_5_year(inputs)
	return en_plan_5_year(inputs)
});